import {
  editorModeFromSegment,
  editorRouteSegments,
  editorSegmentForMode,
  isEditorRouteSegment,
  type EditorRouteMode,
} from './editor'

export const standardFolderRouteSegments = [
  'answers',
  'msges',
  'atts',
  'favs',
  'drafts',
  'trash',
] as const

export const standardEditorRouteSegments = editorRouteSegments
export type StandardEditorMode = EditorRouteMode

export function standardEditorModeFromSegment(segment: string): StandardEditorMode | undefined {
  return editorModeFromSegment(segment)
}

export function standardEditorSegmentForMode(mode: StandardEditorMode): 'new' | 'edit' {
  return editorSegmentForMode(mode)
}

export function isStandardEditorSegment(segment: string): boolean {
  return isEditorRouteSegment(segment)
}

const standardRequestSegmentSet = new Set<string>([
  '',
  ...standardFolderRouteSegments,
  ...standardEditorRouteSegments,
])

export function isStandardRequestSegment(segment: string): boolean {
  return standardRequestSegmentSet.has(segment)
}
